import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { gofor } from '@fiverr-private/futile/lib/gofor';
import { metric } from '@fiverr-private/perseus';
import SafePureComponent from '../shared/SafePureComponent';
import GigGallery from './GigGallery';

import './style.scss';

export const WAVEFORM_BATCH_SIZE = 5;

const formatSlides = (gallery) => {
    if (!gallery || !gallery.slides){
        return [];
    }

    return gallery.slides
        .filter((slideObj) => slideObj && !!slideObj.slide)
        .map((slideObj) => slideObj.slide);
};

class Gallery extends Component {

    constructor(props) {
        super(props);

        this.state = {
            slides: formatSlides(props.gallery)
        };
    }

    componentDidMount() {
        const { slides } = this.state;
        const { general, pathfinderWrapper } = this.context;

        const waveformIds = slides.reduce((acc, slide) => {
            if (slide.itemScopeType === 'AudioSlide') {
                acc.push(slide.waveformId);
            }

            return acc;
        }, []);

        while (waveformIds.length) {
            const waveformIdsBatch = waveformIds.splice(0, WAVEFORM_BATCH_SIZE);
            const url = pathfinderWrapper.pathfinder('gig_page_fetch_waveforms', { gig_id: general.gigId, waveform_ids: waveformIdsBatch });

            gofor(url)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        metric.count(`bad_response.waveform.${response.status}`);

                        return {
                            waveforms: []
                        };
                    }
                })
                .then(({ waveforms }) => {
                    if (!Array.isArray(waveforms) || !waveforms.length) {
                        return;
                    }

                    const newSlides = this.state.slides.map((slide) => {
                        const waveform = waveforms.find((waveform) => waveform.id === slide.waveformId);
                        if (waveform) {
                            return { ...slide, waveform: waveform.waveformData };
                        } else {
                            return slide;
                        }
                    });

                    this.setState({
                        slides: newSlides
                    });
                });
        }
    }

    render() {
        const { isTouch } = this.props;
        const { slides } = this.state;

        return (
            <GigGallery slides={slides} isTouch={isTouch}/>
        );

    }
}

Gallery.propTypes = {
    gallery: PropTypes.object.isRequired,
    isTouch: PropTypes.bool
};

Gallery.contextTypes = {
    general: PropTypes.object,
    pathfinderWrapper: PropTypes.object
};

export { Gallery };
export default SafePureComponent(Gallery);
